import React from "react";
import { FaInstagram, FaYoutube, FaWhatsapp, FaLinkedinIn } from "react-icons/fa";
import { Icon } from "@iconify/react";

export const socialData = [
  {
    id: 1,
    icon: <Icon icon="simple-icons:aparat" className="icon" />,
    url: "https://www.aparat.com/azeto",
  },
  {
    id: 2,
    icon: <FaWhatsapp variant="Bold" size={20} className="icon" />,
    url: "https://api.whatsapp.com/send?phone=989354142159",
  },
  {
    id: 3,
    icon: <FaLinkedinIn className="icon" />,
    url: "https://www.linkedin.com/company/azeto/",
  },
  {
    id: 4,
    icon: <FaInstagram className="icon" />,
    url: "https://www.instagram.com/azeto.ir/",
  },
  {
    id: 5,
    icon: <FaYoutube className="icon" />,
    url: "https://www.youtube.com/channel/UCfNVOqzRl-gyoa3zB__vp4w",
  },
];
